<div class="api-overlay" *ngIf="loading$ | async as message">
  <div class="processing-card">
    <div class="spinner"></div>
    <span class="message">{{ message }}</span>
  </div>
</div>